/* src/app/modules/shared/components/column/column-producer/column-producer.component.scss */
app-column-producer {
  display: contents;
}
/*# sourceMappingURL=column-producer.component.css.map */
